import axios, { AxiosPromise } from 'axios';
import { IPack } from '../../../@types/model/masterData/pack/pack';
import { IPackUpsert } from '../../../@types/model/masterData/pack/packUpsert';

export default class PackHttpService {
    public static getPackData() : AxiosPromise<Array<IPack>> {
        return axios.get(`${API_URL}/v1/Pack/GetAllWeb`);
    }

    public static addOrUpdatePack(upsert : IPackUpsert) : AxiosPromise<IPack> {
        return axios.post(`${API_URL}/v1/Pack/PostPack`, upsert);
    }

    public static deletePack(packId : number) : AxiosPromise<IPack> {
        return axios.delete(`${API_URL}/v1/Pack/Delete`, {
            params : { packId },
        });
    }
}
